import React, { useState, useEffect } from "react";
import axios from 'axios';
import { HiMiniUserGroup } from "react-icons/hi2";
import { FaCheck } from "react-icons/fa";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
function QuickPednigHistory() {
  const [searchTerm, setSearchTerm] = useState('');
  const [fetchQuick, setFetchQuick] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [confirmRow, setConfirmRow] = useState(null);
  const getCurrentMonth = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
  };
  const [selectedMonth, setSelectedMonth] = useState(getCurrentMonth());

  // const [selectedMonth, setSelectedMonth] = useState("");

  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const fetchQuickService = async () => {
    try {
      let url = "https://api.sweepydo.in/fetch-quick-service";
      if (selectedMonth) {
        url += `?month=${selectedMonth}`;
      }
      const res = await axios.get(url);
      const filtered = res.data.filter(item => item.pay_mode?.toLowerCase() === "cash");
      setFetchQuick(filtered);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchQuickService();
  }, []);
  useEffect(() => {
    fetchQuickService();
  }, [selectedMonth]);
  const filteredData = Array.isArray(fetchQuick) ? fetchQuick.filter(itm => Object.values(itm).some(val => String(val).toLowerCase().includes(searchTerm.toLowerCase()))) : [];
  const parsedService = selectedRow?.service ? JSON.parse(selectedRow.service) : [];
  const parsedAddress = selectedRow?.address ? JSON.parse(selectedRow.address) : {};
  const totalPending = fetchQuick.filter(item => !item.receive_status?.toLowerCase().includes("success")).reduce((sum, item) => sum + Number(item.amount || 0), 0);
  const totalReceived = fetchQuick.filter(item => item.receive_status?.toLowerCase().includes("success")).reduce((sum, item) => sum + Number(item.amount || 0), 0);
  const pendingByStaff = fetchQuick.filter(item => !item.receive_status?.toLowerCase().includes("success")).reduce((acc, item) => {
    const name = item.staff_name || "Unknown";
    acc[name] = (acc[name] || 0) + Number(item.amount || 0);
    return acc;
  }, {});
  const getDate = val => {
    if (!val) return null;
    return new Date(val.replace(" ", "T"));
  };
  const todayObj = new Date();
  const currentMonth = todayObj.getMonth();
  const currentYear = todayObj.getFullYear();
  const todayPending = fetchQuick.filter(item => {
    const d = getDate(item.completed_on);
    return d && d.toDateString() === new Date().toDateString() && !item.receive_status?.toLowerCase().includes("success");
  }).reduce((sum, i) => sum + Number(i.amount || 0), 0);
  const todayReceived = fetchQuick.filter(item => {
    const d = getDate(item.completed_on);
    return d && d.toDateString() === new Date().toDateString() && item.receive_status?.toLowerCase().includes("success");
  }).reduce((sum, i) => sum + Number(i.amount || 0), 0);
  const monthData = fetchQuick.filter(item => item.receive_on?.slice(0, 7) === currentMonth);
  const now = new Date();
  const monthPending = fetchQuick.filter(item => {
    const d = getDate(item.completed_on);
    return d && d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear() && !item.receive_status?.toLowerCase().includes("success");
  }).reduce((sum, i) => sum + Number(i.amount || 0), 0);
  const monthReceived = fetchQuick.filter(item => {
    const d = getDate(item.completed_on);
    return d && d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear() && item.receive_status?.toLowerCase().includes("success");
  }).reduce((sum, i) => sum + Number(i.amount || 0), 0);
  const handleMarkPaid = async row => {
    try {
      const payload = {
        pay_status: "Success",
        receive_status: "Success",
        receive_on: new Date().toISOString().slice(0, 19).replace("T", " ")
      };
      await axios.put(`https://api.sweepydo.in/update-quick-payment-status/${row.id}`, payload);
      fetchQuickService();
      showToast("Service transaction verify sucessfully!", 'success');
    } catch (error) {
      console.log(error);
      showToast("Fail to verify service transaction", 'danger');
    }
  };
  return <div className="container-fluid mt-3 mb-3" style={{
    minHeight: "100vh"
  }}>
  
              <h2 className="mb-4 text-white text-center"> Pending Collection</h2>
    <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
      ...toast,
      show: false
    })} />






<div className="row g-3 mb-3">

  {/* TODAY */}
  <div className="col-md-6">
    <div className="card bg-dark text-white border border-secondary shadow-sm h-100">
      <div className="card-body" style={{
            backgroundColor: "var(--black)",
            minHeight: "140px"
          }}>

       <h6 className="text-white mb-3">📅 Today Collection</h6>

        <div className="d-flex justify-content-between mb-2">
          <span>Pending</span>
          <span className="text-warning fw-bold">₹ {todayPending}</span>
        </div>

        <div className="d-flex justify-content-between">
          <span>Received</span>
          <span className="text-success fw-bold">₹ {todayReceived}</span>
        </div>

      </div>
    </div>
  </div>

  {/* MONTH */}
  <div className="col-md-6">
    <div className="card bg-dark text-white border border-secondary shadow-sm h-100">
      <div className="card-body" style={{
            backgroundColor: "var(--black)",
            minHeight: "140px"
          }}>

        <h6 className="text-white mb-3">📅 This Month Collection</h6>

        <div className="d-flex justify-content-between mb-2">
          <span>Pending</span>
          <span className="text-warning fw-bold">₹ {monthPending}</span>
        </div>

        <div className="d-flex justify-content-between">
          <span>Received</span>
          <span className="text-success fw-bold">₹ {monthReceived}</span>
        </div>

      </div>
    </div>
  </div>

</div>


{/* STAFF BREAKDOWN */}
<div className="col-md-6">
<div className="card text-white shadow-sm mb-3 border-0" style={{
        backgroundColor: "var(--black)",
        minHeight: "140px"
      }}>
  <div className="card-body">

    <h6 className="text-light mb-3">Pending by Staff</h6>

    {Object.keys(pendingByStaff).length === 0 ? <p className="text-success mb-0">No pending collection 🎉</p> : Object.entries(pendingByStaff).map(([name, amount], idx) => <div key={idx} className="d-flex justify-content-between align-items-center py-2 border-bottom border-secondary">
          <span>{name}</span>
          <span className="fw-semibold text-warning">₹ {amount}</span>
        </div>)}

  </div>
</div>
</div>




              <div className="card shadow-lg border-0 p-3 " style={{
      background: "var(--black)",
      borderRadius: "12px"
    }}>
                  <div style={{
        background: "var(--black)",
        borderRadius: "12px",
        padding: "15px"
      }}>
  
                   

                      <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2 py-4">

  {/* Search */}
  <input type="text" className="form-control w-auto" placeholder="Search..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />

  {/* Month Filter */}
  <input type="month" className="form-control w-auto" value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)} />

</div>
  
                      <div className="table-responsive">
                          <table className="text-center" style={{
            width: "100%",
            borderCollapse: "collapse",
            color: "#fff"
          }}>
  
                              <thead>
                                  <tr style={{
                backgroundColor: "var(--black2)"
              }}>
                                      <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>SN</th>
                                      <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>SERVICE ID</th>
                                      <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>USER NAME</th>
                                      <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>USER MOBILE</th>
  
                                 
  
  
                                      <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>STAFF NAME</th>
                                      <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>STAFF MOBILE</th>
                                      <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>AMOUNT</th>
                               <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>PAYMENT MODE</th>
                                     <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>RECEIVE STATUS</th>
                                      <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>ACTION</th>
  
  
                                  </tr>
                              </thead>
  
  
                              {filteredData.map((s, idx) => <React.Fragment key={s.id}>
                                      <tr style={{
                backgroundColor: "var(--black)",
                borderBottom: "1px solid rgba(255,255,255,0.06)",
                transition: "0.3s"
              }} onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = "var(--black2)";
              }} onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = "var(--black)";
              }}>
                                          <td style={{
                  padding: "18px",
                  textAlign: "center",
                  verticalAlign: "middle"
                }}>{idx + 1}</td>
                                          <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>
                                              {`QSID${s.id}`}</td>
                                          <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{s.users_name}</td>
  
                                          <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{s.users_mobile}</td>
  
                                     
                                          <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}> {s.staff_name} </td>
                                          <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{s.staff_mobile} </td>
                                                      <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{s.amount} </td>
  
                                          <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{s.pay_mode} </td>
                                          <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{s.receive_status} </td>
  
                                       

                                          <td className="d-flex justify-content-center gap-2 mt-3">

  {/* View Button */}
  <button className="btn btn-sm btn-info" onClick={() => {
                    setSelectedRow(s);
                    setShowModal(true);
                  }}>
    View
  </button>

  {/* Mark as Paid Button */}
<button className="btn btn-sm btn-success" title="Mark as Paid" disabled={s.receive_status?.toLowerCase().includes("success")} onClick={() => setConfirmRow(s)}>
  <FaCheck />
</button>

</td>
  
                                      </tr>
  
  
                                  </React.Fragment>)}
  
                          </table>
                      </div>
                  </div>
                  {showModal && selectedRow && <div className="modal fade show" style={{
        display: "block",
        background: "rgba(0,0,0,0.6)"
      }}>
                          <div className="modal-dialog modal-lg">
                              <div className="modal-content" style={{
            backgroundColor: "var(--black)",
            color: "#fff",
            border: "1px solid #2d3748"
          }}>
  
                                  {/* Header */}
                                  <div className="modal-header">
                                      <h5 className="modal-title">Service Details</h5>
                                      <button className="btn-close" onClick={() => setShowModal(false)}></button>
                                  </div>
  
                                  {/* Body */}
                                  <div className="modal-body bg-dark text-white">
  
                                      {/* USER */}
                                      <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-info border-4">
                                          <h6 className="text-info">User Details</h6>
                                          <p><b>User:</b> {selectedRow.users_name}</p>
                                          <p><b>Mobile:</b> {selectedRow.users_mobile}</p>
                                      </div>
  
                                      {/* CONTACT */}
                                      <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-secondary border-4">
                                          <h6 className="text-secondary">Contact Details</h6>
                                          <p><b>Contact Person:</b> {selectedRow.contact_name}</p>
                                          <p><b>Contact No:</b> {selectedRow.contact_no}</p>
                                      </div>
  
                                      {/* SERVICE */}
                                      <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-info border-4">
                                          <h6 className="text-info">Service Details</h6>
                                          {parsedService.map((srv, i) => <div key={i}>
                                                  <p><b>Name:</b> {srv.name}</p>
                                                  <p><b>Price:</b> ₹{srv.sale_price}</p>
                                                  <p><b>Duration:</b> {srv.mins} mins</p>
                                              </div>)}
                                      </div>
  
                                      {/* PAYMENT */}
                                      <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-secondary border-4">
                                          <h6 className="text-secondary">Payment Details</h6>
                                          <p><b>Amount:</b> ₹{selectedRow.amount}</p>
                                          <p><b>Tax:</b> ₹{selectedRow.tax}</p>
                                          <p><b>Mode:</b> {selectedRow.pay_mode}</p>
                                          <p><b>Payment ID:</b> {selectedRow.pay_id}</p>
                                          <p>
                                              <b>Status:</b>{" "}
                                              <span className={selectedRow.pay_status?.toLowerCase().includes("success") ? "text-success fw-bold" : "text-danger fw-bold"}>
                                                  {selectedRow.pay_status}
                                              </span>
                                          </p>

                                            <p><b>Received Date:</b> {selectedRow.receive_on}</p>
                                         <p><b>Received Status:</b> {selectedRow.receive_status}</p>
                                      </div>
  
                                      {/* ADDRESS */}
                                      <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-info border-4">
                                          <h6 className="text-info">Address</h6>
                                          <p>{parsedAddress.name}</p>
                                          <p>{parsedAddress.locality}, {parsedAddress.state}</p>
                                          <p>{parsedAddress.country} - {parsedAddress.pincode}</p>
                                      </div>
  
                                      {/* STATUS */}
                                      <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-secondary border-4">
                                          <h6 className="text-secondary">Service Status</h6>
                                          <p><b>Status:</b> {selectedRow.service_status}</p>
                                        
                                      </div>
  
                                  </div>
  
                                  {/* Footer */}
                                  <div className="modal-footer">
                                      <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                                          Close
                                      </button>
                                  </div>
  
                              </div>
                          </div>
                      </div>}


                  {confirmRow && <div className="modal fade show" style={{
        display: "block",
        background: "rgba(0,0,0,0.6)"
      }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content bg-dark text-white border border-secondary">

        {/* Header */}
        <div className="modal-header">
          <h5 className="modal-title text-warning">Confirm Payment</h5>
          <button className="btn-close btn-close-white" onClick={() => setConfirmRow(null)}></button>
        </div>

        {/* Body */}
        <div className="modal-body text-center">
          <p>
            Are you sure you want to verify this service transaction?
          </p>

          <p className="fw-bold text-info">
            Service ID: QSID{confirmRow.id}
          </p>
        </div>

        {/* Footer */}
        <div className="modal-footer justify-content-center">

          <button className="btn btn-secondary" onClick={() => setConfirmRow(null)}>
            Cancel
          </button>

          <button className="btn btn-success" onClick={() => {
                handleMarkPaid(confirmRow);
                setConfirmRow(null);
              }}>
            Confirm
          </button>

        </div>

      </div>
    </div>
  </div>}
  
  
              </div>
          </div>;
}
export default QuickPednigHistory;
